var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitHubIcon = function SvgGitHubIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.28 0a11.28 11.28 0 0 0-3.566 21.986c.561.104.769-.25.769-.547v-1.918c-3.137.692-3.802-1.51-3.802-1.51a3.02 3.02 0 0 0-1.253-1.655c-1.018-.692.083-.692.083-.692a2.38 2.38 0 0 1 1.724 1.163 2.41 2.41 0 0 0 3.282.942c.044-.57.29-1.105.693-1.51-2.507-.284-5.138-1.253-5.138-5.574a4.36 4.36 0 0 1 1.156-3.026 4.1 4.1 0 0 1 .111-2.985s.949-.304 3.102 1.157a10.67 10.67 0 0 1 5.65 0c2.155-1.461 3.096-1.157 3.096-1.157.415.945.457 2.01.118 2.985a4.36 4.36 0 0 1 1.156 3.026c0 4.335-2.638 5.284-5.152 5.54a2.67 2.67 0 0 1 .77 2.077v3.096c0 .367.2.65.775.547A11.287 11.287 0 0 0 11.28-.042z",
    clipRule: "evenodd"
  })));
};
export default SvgGitHubIcon;